<div class="predittore-scompenso">
    <h3>Dati del Paziente</h3>
    <div class="patient-info" *ngIf="patientData">
        <div class="info-row">
            <span class="info-label">Età:</span> <span>{{ patientData.age }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">Sesso:</span> <span>{{ getGenereLabel(patientData.sex) }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">SBP (mmHg):</span> <span>{{ patientData.sbp || 'Non disponibile' }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">Colesterolo Totale (mg/dL):</span> <span>{{ patientData.totalCholesterol || 'Non
                disponibile' }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">Colesterolo HDL (mg/dL):</span> <span>{{ patientData.hdlCholesterol || 'Non disponibile' }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">Fumatore:</span> <span>{{ patientData.smoking ? 'Sì' : 'No' }}</span>
        </div>
        <div class="info-row">
            <span class="info-label">Diabete:</span> <span>{{ patientData.diabetes ? 'Sì' : 'No' }}</span>
        </div>
    </div>

    <h3>Predizione Scompenso Cardiaco In 10 Anni</h3>
    <div class="score-result" *ngIf="score2OpResult !== undefined">
        <p-knob [(ngModel)]="score2OpResult" [min]="0" [max]="100" [size]="150" valueTemplate="{value}%"
            [readonly]="true" [showValue]="true" unit="%" [valueColor]="getScoreColorClass()">
        </p-knob>
    </div>
    <div class="info-row" *ngIf="score2OpResult === undefined">
        <h5 class="info-label">Non è stato possibile calcolare il punteggio a causa della mancanza di alcuni
            dati</h5>
    </div>

    <div class="score-legend" *ngIf="score2OpResult !== undefined">
        <div class="legend-item">
            <span class="color-box green"></span> 0 - 15%: Basso rischio
        </div>
        <div class="legend-item">
            <span class="color-box yellow"></span> 16 - 30%: Rischio moderato
        </div>
        <div class="legend-item">
            <span class="color-box red"></span> 31% e oltre: Alto rischio
        </div>
    </div>
</div>